import React from "react";
import style from "../../styles/instructionview";
export default (props) => {
  return (
    <div>
      {(props.numSets ||
        props.numRepetitions ||
        props.duration ||
        props.intensity ||
        props.frequency) && <h4 style={style.borderBottom}>Details</h4>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/InstructionHeader.js